import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-24 bg-trino-burgundy text-trino-cream relative overflow-hidden" data-id="element-113">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-trino-gold to-transparent opacity-50" data-id="element-114"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-116">
          <p className="text-xl sm:text-2xl font-serif italic text-trino-peach leading-relaxed mb-8" data-id="element-117">
            "¿Sientes que estás leyendo piezas de rompecabezas de diferentes
            cajas? Tienes tu carta natal por un lado, tu número de vida por
            otro, y quizás tu Kin Maya por otro. Pero al final del día, sigues
            sintiendo una desconexión profunda entre lo que haces, lo que
            sientes y lo que tu alma te grita."
          </p>
          <p className="text-lg text-trino-cream/90 font-light" data-id="element-118">
            No eres una sola etiqueta.{' '}
            <span className="font-bold text-trino-gold" data-id="element-119">
              Eres una frecuencia trina.
            </span>{' '}
            Y mientras no entiendas cómo estas tres fuerzas se hablan entre sí,
            estarás operando con el "software" equivocado, desperdiciando
            energía en metas que no te pertenecen.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white/5 border border-white/10 rounded-2xl p-8 sm:p-12 backdrop-blur-sm relative" data-id="element-120">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-trino-burgundy border border-trino-gold/30 px-6 py-2 rounded-full" data-id="element-121">
            <span className="text-trino-gold text-sm tracking-widest uppercase font-semibold" data-id="element-122">
              El Problema Real
            </span>
          </div>

          <h2 className="text-3xl font-serif text-center mb-8 mt-4" data-id="element-123">
            El "Caos Constructivo"
          </h2>

          <div className="space-y-6 text-trino-cream/80 text-lg font-light leading-relaxed" data-id="element-124">
            <p data-id="element-125">
              La mayoría de las personas viven en un estado de "caos
              constructivo". Intentan avanzar, pero sienten una resistencia
              invisible. Sabes que tienes talento, sabes que tienes una misión,
              pero no logras aterrizarla en resultados concretos de abundancia y
              libertad.
            </p>
            <p data-id="element-126">
              El problema no es que te falte capacidad. El problema es que
              intentas ser un "líder" cuando tu código base es de
              "investigador", o intentas "retener" cuando tu sello energético es
              de "soltar y enlazar".
            </p>
            <p className="text-center text-xl font-medium text-trino-peach mt-8" data-id="element-127">
              Estás luchando contra tu propio diseño original.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}